var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SvgIcon',{staticClass:"bc-favorite-icon",class:{ 'is_favorite': _vm.isFavorite },attrs:{"name":"star"},on:{"click":function($event){$event.stopPropagation();return _vm.toggleFavorite.apply(null, arguments)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }